import React, {Fragment} from 'react';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const getUrl = (path, sub, index) => {
  if (index === 0) {
    return '';
  } else {
    return path.split(sub)[0] + sub;
  }
};

const BreadcrumbContainer = ({heading, match}) => {
  return (
    <Fragment>
      {heading && <h1>{heading}</h1>}
      <BreadcrumbItems match={match}/>
    </Fragment>
  );
};

class _BreadcrumbItems extends React.Component {

  componentDidMount() {
    this.applyTitle();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.locale !== this.props.locale) {
      this.applyTitle();
    }
  }


  applyTitle = () => {
    const {match, t} = this.props;
    const path = match.path.substr(1);
    let paths = path.split('/');
    if (paths[paths.length - 1].indexOf(':') > -1) {
      paths = paths.filter(x => x.indexOf(':') === -1);
    }

    const titles = paths.map((sub) => {
      const Sub = (sub.charAt(0).toUpperCase() + sub.substr(1)).replace(/-/g, ' ');
      return t([sub, Sub]);
    });

    document.title = '' + titles.join(' | ');
  };

  render() {
    const {match, t} = this.props;
    const path = match.path.substr(1);
    let splited = path.split('/');
    let paths = splited.slice(0, splited.length - 1);
    if (paths[paths.length - 1].indexOf(':') > -1) {
      paths = paths.filter(x => x.indexOf(':') === -1);
    }
    return (
      <Fragment>
        <Breadcrumb className="pt-0 breadcrumb-container d-none d-sm-block d-lg-inline-block text-one">
          {paths.map((sub, index) => {
            const Sub = (sub.charAt(0).toUpperCase() + sub.substr(1)).replace(/-/g, ' ');
            return (
              <BreadcrumbItem key={index} active={paths.length === index + 1}>
                <NavLink to={'/' + getUrl(path, sub, index)}>
                  {t([sub, Sub])}
                </NavLink>
              </BreadcrumbItem>
            );
          })}
        </Breadcrumb>
      </Fragment>
    );
  }
}

const mapStateToProps = ({settings}) => {
  const {locale} = settings;
  return {locale};
};

export const BreadcrumbItems = withTranslation()(connect(
  mapStateToProps,
)(_BreadcrumbItems));

export default BreadcrumbContainer;
